import { ShaderMaterial } from 'three';

import { vert } from './vertex';
import { frag } from './fragment';

export class PostProcessingMaterial extends ShaderMaterial {
  /**
   *
   * @param {import("three").ShaderMaterialParameters} options
   */
  constructor(options = {}) {
    options.vertexShader = vert;
    options.fragmentShader = frag;
    super(options);
  }
}
